import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { getConfig, microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { useFeatureFlipping } from '@b2ag/feature-flipping'
import { createError } from '#imports'
import { isFarmi } from '@b2ag/app-brands'

/* ------- MICROFRONT - FARMI APP APPRO ------- */

export const farmiAppApproRoutes = [
  {
    path: '/farmi/app/input/categories',
    name: 'farmi-app-appro-categories',
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'categories',
    }),
    beforeEnter(_, __, next) {
      if (!isWebViewFarmi()) throw createError({ statusCode: 404 })
      else {
        microFrontListener({
          iframe: { href: window.location.origin },
          analyticService: useAnalyticService(),
        })
        next()
      }
    },
  },
  {
    path: '/farmi/app/appro/chatbot',
    name: 'farmi-app-appro-chatbot',
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'chatbot',
    }),
    beforeEnter(_, __, next) {
      if (!isFarmi || getConfig('ENVIRONMENT_NAME') !== 'QUA') throw createError({ statusCode: 404 })
      else next()
    },
  },
  {
    path: '/farmi/app/appro/analytics',
    name: 'farmi-app-appro-analytics',
    component: () => import('@b2ag/micro-front-farmi-app-appro/app'),
    meta: {
      showAppHeader: false,
    },
    props: () => ({
      microFrontName: 'farmi-app-appro',
      viewName: 'analytics',
    }),
    beforeEnter(_, __, next) {
      const { isCopilotArcDashboardEnabled } = useFeatureFlipping()

      if (isWebViewFarmi() && getConfig('DASHBOARD_METABASE_APPRO_VIEW_PAGES_ID') && isCopilotArcDashboardEnabled.value)
        next()
      else throw createError({ statusCode: 404 })
    },
  },
]
